import React from "react";
import { StyledCircle } from "./styled";
import { CircleProps } from "../../types/CircleProps";
import { Tooltip } from "@mui/material";

const Circle = ({ color, toolTipTitle }: CircleProps) => {
  return (
    <Tooltip title={toolTipTitle} placement="top-end" arrow>
      <StyledCircle color={color} />
    </Tooltip>
  );
};

export default Circle;
